module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_1-56bc641677e93e6ab544f26b6da31774.webp";